// extracted by mini-css-extract-plugin
module.exports = {"rootFontWrapper":"fonts_rootFontWrapper__sDu5J"};